"use strict";
var __defProp = Object.defineProperty;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __publicField = (obj, key, value) => __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
import { jsx, jsxs } from "react/jsx-runtime";
import React from "react";
import ValueLinkTextDroppableInput from "../value_link_text_droppable_input";
const DEFAULT_INVOICE = { id: "new" };
export default class extends React.Component {
  constructor() {
    super(...arguments);
    // Wrap each input so it can be focused without reaching into the input component.
    __publicField(this, "amountWrapperRef", React.createRef());
    __publicField(this, "numberWrapperRef", React.createRef());
    __publicField(this, "invoiceInput", (field, placeholder, type) => {
      var _a, _b;
      return /* @__PURE__ */ jsx(
        ValueLinkTextDroppableInput,
        {
          type,
          disabled: this.invoiceIsReadOnly(),
          value: (_b = (_a = this.fieldValue(field)) != null ? _a : this.carrierInvoice()[field]) != null ? _b : "",
          onValueChange: (value) => this.props.onFieldChange(field, value),
          placeholder,
          className: "mousetrap-allow-text"
        }
      );
    });
    __publicField(this, "fieldValue", (field) => {
      return field === "source_invoice_amount" ? this.props.sourceInvoiceAmount : this.props.sourceInvoiceNumber;
    });
    __publicField(this, "invoiceIsReadOnly", () => {
      return this.carrierInvoice() && (this.carrierInvoice().state === "approved" || this.carrierInvoice().state === "abandoned");
    });
    __publicField(this, "carrierInvoice", () => {
      return this.props.getSelectedInvoiceForGroup(DEFAULT_INVOICE);
    });
    __publicField(this, "focusNextField", () => {
      setTimeout(() => {
        var _a, _b, _c, _d;
        const isReadOnly = this.invoiceIsReadOnly();
        const needsInvoiceAmt = !(this.props.sourceInvoiceAmount || this.carrierInvoice().source_invoice_amount) && !isReadOnly;
        const needsInvoiceNum = !(this.props.sourceInvoiceNumber || this.carrierInvoice().source_invoice_number) && !isReadOnly;
        if (needsInvoiceAmt) {
          (_b = (_a = this.amountWrapperRef.current) == null ? void 0 : _a.querySelector("input")) == null ? void 0 : _b.focus();
        } else if (needsInvoiceNum) {
          (_d = (_c = this.numberWrapperRef.current) == null ? void 0 : _c.querySelector("input")) == null ? void 0 : _d.focus();
        } else {
          const firstRadioAssigner = document.querySelector(
            'input[name="carrier-invoice-chooser"]:checked'
          ) || document.querySelector(
            'input[name="carrier-invoice-chooser"]'
          );
          if (firstRadioAssigner) {
            firstRadioAssigner.focus();
          }
        }
      });
    });
  }
  render() {
    return /* @__PURE__ */ jsxs("div", { className: "load-assigner__invoice-input-fields", children: [
      /* @__PURE__ */ jsx("h4", { children: "Verify Invoice Data" }),
      /* @__PURE__ */ jsxs("div", { className: "row load-assigner__invoice-input-fields__inputs", children: [
        /* @__PURE__ */ jsxs("div", { className: "medium-5 columns", children: [
          /* @__PURE__ */ jsx("label", { children: "Invoice Amount" }),
          /* @__PURE__ */ jsxs("div", { className: "row collapse", children: [
            /* @__PURE__ */ jsx("div", { className: "small-1 columns", children: /* @__PURE__ */ jsx("span", { className: "prefix", children: "$" }) }),
            /* @__PURE__ */ jsx("div", { className: "small-9 columns", ref: this.amountWrapperRef, children: this.invoiceInput(
              "source_invoice_amount",
              "Total Charge",
              "text"
            ) })
          ] })
        ] }),
        /* @__PURE__ */ jsxs("div", { className: "medium-5 columns", ref: this.numberWrapperRef, children: [
          /* @__PURE__ */ jsx("label", { children: "Invoice Number" }),
          this.invoiceInput(
            "source_invoice_number",
            "Invoice Number",
            "text"
          )
        ] })
      ] })
    ] });
  }
}
